module.exports = __webpack_public_path__ + "static/img/zqbh.f3af6516.png";